import React from "react";
import { DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { formatTimeZone, getAllTimeZones } from "shared/utils/dateTimeUtils";

const TimezoneDropdown = (props: DropdownWithoutOptionsProps<string, string>) => {
  const timezones = getAllTimeZones(serverReference.culture.uiLocale);

  const selectedTimezone = timezones.find(tz => tz.value === props.value);

  return <BaseReactSelectDropdown
    options={timezones}
    value={selectedTimezone}
    onChange={tz => { props.onChange(tz.value); }}
    getLabel={tz => tz.value}
    getSubLabel={tz => formatTimeZone(tz)}
    getValue={tz => tz.value}
    getSearchString={tz => `${tz.longName} ${tz.value} ${tz.offset}`}
    excludeKeys={[]}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />
}

export default TimezoneDropdown;
